#import "../nut-email-address-fragment.graphql"

fragment EmailQueuedFragmentFull on EmailQueued {
    id
    subject
    bodyExcerpt
    # Alias because bodyHtml type for Email is !String which conflicts with type Note's bodyHtml type String
    emailBodyHtml: bodyHtml
    attachments {
        fileId
        name
        href
        fileType
    }
    to {
        ...NutEmailAddressFragment
    }
    from {
        ...NutEmailAddressFragment
    }
    canRetry
    isFailed
    htmlUrl
}
